/**
 * Utils for date
 * const date = new DateTimeVO()
 * date.fromDateAndTimeString('10/07/2025 13:45:21') // '10/07/2025 às 13:45'
 */

export const dateTimeHandle = {
	fromDateAndTimeString(date: string): string {
		const [dateString, timeString] = date.split(' ');
		const formattedTime = timeString?.substring(0, 5) ?? '';
		return `${dateString} às ${formattedTime}`.trim();
	},
};
